(() => {
let config = {};
try { config = JSON.parse(document.querySelector('#xf-navigation-config')?.textContent || '{}'); } catch (error) { console.error('Store navigation configuration could not load:', error); }
const rootPrefix = String(config.rootUrl || '/').replace(/\/+$/, '');
const cartIcon = document.querySelector('#cart-icon-bubble');
if (cartIcon) {
  const updateCartLabel = () => {
    const label = cartIcon.querySelector('[data-xf-cart-label]')?.textContent.trim();
    if (label) cartIcon.setAttribute('aria-label', label);
  };
  updateCartLabel();
  new MutationObserver(updateCartLabel).observe(cartIcon, {childList:true, subtree:true, characterData:true});
}
const menuDialog = document.querySelector('#menu-dialog');
const tabs = document.querySelector('#department-tabs');
const panels = document.querySelector('#department-panels');
const browser = document.querySelector('.menu-browser');
const search = document.querySelector('#menu-search');
const results = document.querySelector('#menu-results');
const status = document.querySelector('#menu-search-status');
const clear = document.querySelector('#menu-search-clear');
const mobileSelect = document.querySelector('#department-mobile-select');
const mobile = matchMedia('(max-width: 767px)');
const escapeMenu = value => String(value).replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
const normalise = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('en-AU');
const fallback = {label:'Shop all products',href:`${rootPrefix}/collections/all`};
let menuData = null, searchLinks = [], selectedId = null, ownedTrigger = null, ownedDepartment = null, fetching = false, pendingDepartment = null;

function safeLink(link) {
  if (!link || typeof link.label !== 'string' || !link.label.trim()) throw new Error('Menu label missing');
  const url = new URL(link.href, location.origin);
  const path = rootPrefix && url.pathname.startsWith(`${rootPrefix}/`) ? url.pathname.slice(rootPrefix.length) : url.pathname;
  const productSearch = path === '/search' && url.searchParams.get('type') === 'product' && Boolean(url.searchParams.get('q')?.trim());
  if (url.origin !== location.origin || url.username || url.password || !/^\/(collections|pages)\//.test(path) && !productSearch) throw new Error('Unexpected menu destination');
  return {label:link.label.trim(),href:`${rootPrefix}${path}${url.search}${url.hash}`};
}
function iconImage(name) {
  const source = config.icons?.[name] || config.icons?.list;
  return source ? `<img src="${escapeMenu(source)}" alt="">` : '';
}
function linkHTML(link, detail = '') {
  return `<a class="menu-category-link${detail ? ' menu-result-link' : ''}" href="${escapeMenu(link.href)}"><span>${detail ? `<strong>${escapeMenu(link.label)}</strong><small class="menu-result-meta">${escapeMenu(detail)}</small>` : escapeMenu(link.label)}</span>${iconImage('arrow-up-right')}</a>`;
}
function validate(data) {
  const ids = new Set();
  if (!Array.isArray(data?.departments) || !data.departments.length) throw new Error('No departments available');
  return {
    allProducts:safeLink(data.allProducts),
    departments:data.departments.map((department, index) => {
      if (!department || typeof department.label !== 'string' || !department.label.trim() || !Array.isArray(department.sections)) throw new Error('Invalid department');
      const id = /^[a-z][a-z0-9-]*$/.test(department.id) ? department.id : `department-${index}`;
      if (ids.has(id)) throw new Error('Duplicate department');
      ids.add(id);
      const icon = typeof department.icon === 'string' && /^[a-z0-9-]+$/.test(department.icon) ? department.icon : 'list';
      const browseLink = department.browseLink ? safeLink(department.browseLink) : null;
      const featured = department.featured ? {...safeLink(department.featured),imageKey:String(department.featured.imageKey || ''),alt:String(department.featured.alt || '')} : null;
      return {id,label:department.label.trim(),icon,lead:typeof department.lead === 'string' ? department.lead : '',browseLink,featured,sections:department.sections.map(section => {
        if (!section || typeof section.label !== 'string' || !Array.isArray(section.links)) throw new Error('Invalid menu section');
        return {label:section.label,links:section.links.map(safeLink)};
      })};
    })
  };
}
function setOrientation() {
  tabs?.setAttribute('aria-orientation', 'vertical');
}
function focusDepartmentControl() {
  if (mobile.matches && mobileSelect) mobileSelect.focus();
  else tabs.querySelector('[aria-selected="true"]')?.focus();
}
function selectDepartment(id, moveFocus = false) {
  if (!menuData?.departments.some(department => department.id === id)) return;
  selectedId = id;
  for (const tab of tabs.querySelectorAll('[role="tab"]')) {
    const active = tab.dataset.department === id;
    tab.setAttribute('aria-selected', String(active));
    tab.tabIndex = active ? 0 : -1;
  }
  if (mobileSelect) mobileSelect.value = id;
  for (const panel of panels.querySelectorAll('[role="tabpanel"]')) panel.hidden = panel.id !== `panel-${id}`;
  if (moveFocus) focusDepartmentControl();
}
function buildSearchIndex() {
  const indexed = new Map();
  for (const department of menuData.departments) {
    const sections = [...department.sections];
    const leadingLinks = [department.browseLink,department.featured].filter(Boolean);
    if (leadingLinks.length) sections.push({label:department.label,links:leadingLinks});
    for (const section of sections) for (const link of section.links) {
      if (!indexed.has(link.href)) indexed.set(link.href, {...link,departments:new Set(),terms:new Set()});
      const item = indexed.get(link.href);
      item.departments.add(department.label);
      for (const term of [link.label,department.label,section.label]) item.terms.add(term);
    }
  }
  searchLinks = [...indexed.values()].map(item => ({...item,context:[...item.departments].join(' · '),searchText:normalise([...item.terms].join(' '))}));
}
function renderDepartments() {
  tabs.setAttribute('role','tablist');
  tabs.setAttribute('aria-label','Shop departments');
  setOrientation();
  tabs.innerHTML = menuData.departments.map((department,index) => `<button type="button" class="department-tab" id="tab-${department.id}" role="tab" data-department="${department.id}" aria-controls="panel-${department.id}" aria-selected="${index===0}" tabindex="${index===0?'0':'-1'}">${iconImage(department.icon)}<span>${escapeMenu(department.label)}</span></button>`).join('');
  panels.innerHTML = menuData.departments.map((department,index) => `<section class="department-panel" id="panel-${department.id}" role="tabpanel" aria-labelledby="tab-${department.id}" tabindex="0" ${index===0?'':'hidden'}><div class="department-intro"><p class="department-kicker">Shop by department</p><h3>${escapeMenu(department.label)}</h3>${department.lead ? `<p class="department-lead">${escapeMenu(department.lead)}</p>` : ''}${department.browseLink ? `<a class="department-browse" href="${escapeMenu(department.browseLink.href)}">${escapeMenu(department.browseLink.label)}${iconImage('arrow-up-right')}</a>` : ''}</div><div class="department-content"><div class="department-columns">${department.sections.map(section => `<div class="menu-link-group"><h4>${escapeMenu(section.label)}</h4>${section.links.map(link => linkHTML(link)).join('')}</div>`).join('')}</div>${featureHTML(department.featured)}</div></section>`).join('');
  if (mobileSelect) {
    mobileSelect.innerHTML = menuData.departments.map(department => `<option value="${department.id}">${escapeMenu(department.label)}</option>`).join('');
    mobileSelect.setAttribute('aria-controls','department-panels');
  }
  selectedId = menuData.departments[0].id;
  buildSearchIndex();
  selectDepartment(pendingDepartment || selectedId);
  pendingDepartment = null;
}
function featureHTML(feature) {
  const source = feature && config.images?.[feature.imageKey];
  if (typeof source !== 'string' || !source.trim()) return '';
  let image;
  try { image = new URL(source,location.origin); } catch { return ''; }
  if (image.protocol !== 'https:' && image.origin !== location.origin) return '';
  return `<a class="department-feature" href="${escapeMenu(feature.href)}"><img src="${escapeMenu(image.href)}" alt="${escapeMenu(feature.alt)}" width="480" height="600" loading="lazy"><span>${escapeMenu(feature.label)}${iconImage('arrow-up-right')}</span></a>`;
}
function renderSearch() {
  if (!menuData) return;
  const query = search.value.trim();
  const searching = query.length > 0;
  browser.hidden = searching;
  if (mobileSelect) mobileSelect.hidden = searching;
  results.hidden = !searching;
  clear.hidden = !searching;
  if (!searching) { results.innerHTML='';status.textContent='';return; }
  const tokens = normalise(query).split(/\s+/);
  const matches = searchLinks.filter(link => tokens.every(token => link.searchText.includes(token)));
  status.textContent = `${matches.length} ${matches.length===1?'category':'categories'} found for “${query}”.`;
  results.innerHTML = matches.length ? `<div class="menu-results-heading"><h3>Search results</h3><p class="menu-search-count">${matches.length} ${matches.length===1?'category':'categories'}</p></div><div class="menu-results-grid">${matches.map(link => linkHTML(link,link.context)).join('')}</div>` : `<div class="menu-no-results"><h3>No matching categories.</h3><p>Try a different search or explore the complete catalogue.</p>${linkHTML(menuData.allProducts)}</div>`;
}
async function loadMenu() {
  if (fetching || !tabs || !panels || !browser || !search || !results || !status || !clear) return;
  fetching = true;
  menuData = null;
  if (mobileSelect) mobileSelect.disabled = true;
  search.disabled = true;
  clear.hidden = true;
  browser.hidden = true;
  results.hidden = false;
  results.setAttribute('aria-busy','true');
  results.innerHTML = '<p class="menu-loading">Loading departments...</p>';
  status.textContent = 'Loading departments.';
  try {
    if (!config.menuDataUrl) throw new Error('Menu asset URL missing');
    const response = await fetch(config.menuDataUrl);
    if (!response.ok) throw new Error(`Menu request failed (${response.status})`);
    menuData = validate(await response.json());
    renderDepartments();
    search.disabled = false;
    if (mobileSelect) mobileSelect.disabled = false;
    renderSearch();
    if (menuDialog.open && ownedDepartment) focusDepartmentControl();
  } catch (error) {
    results.hidden = false;
    browser.hidden = true;
    results.innerHTML = `<div class="menu-error"><h3>The department menu could not load.</h3><p>You can still browse every product in the store.</p>${linkHTML(fallback)}<button type="button" id="menu-retry">Try loading the menu again</button></div>`;
    status.textContent = 'Departments unavailable. A link to all products is available below.';
    console.error('Store department menu could not load:',error);
  } finally {
    fetching = false;
    results.setAttribute('aria-busy','false');
  }
}
function openShopAll(trigger, departmentId = null) {
  if (!menuDialog) return;
  if (departmentId) {
    search.value = '';
    if (menuData) { selectDepartment(departmentId); renderSearch(); }
    else pendingDepartment = departmentId;
  }
  if (menuDialog.open) { if (departmentId && menuData) focusDepartmentControl(); return; }
  ownedTrigger = trigger;
  ownedDepartment = trigger?.dataset.shopDepartment || null;
  for (const dialog of document.querySelectorAll('dialog[open]')) dialog.close();
  for (const button of document.querySelectorAll('#menu-button,#shop-all-button,#footer-shop-all,[data-shop-department]')) button.setAttribute('aria-expanded','true');
  menuDialog.showModal();
  if (menuData && !search.value.trim()) focusDepartmentControl();
  else if (menuData) search.focus();
}

if (menuDialog && tabs && panels && browser && search && results && status && clear) {
  status.setAttribute('role','status');
  search.addEventListener('input',renderSearch);
  clear.addEventListener('click',()=>{search.value='';renderSearch();search.focus();});
  mobileSelect?.addEventListener('change',()=>{search.value='';renderSearch();selectDepartment(mobileSelect.value);});
  tabs.addEventListener('click',event=>{const tab=event.target.closest('[role="tab"]');if(tab)selectDepartment(tab.dataset.department);});
  tabs.addEventListener('keydown',event=>{
    const tab=event.target.closest('[role="tab"]');
    if(!tab||!menuData)return;
    const departmentIds=menuData.departments.map(department=>department.id);
    let index=departmentIds.indexOf(tab.dataset.department);
    if(event.key==='Home')index=0;
    else if(event.key==='End')index=departmentIds.length-1;
    else if(['ArrowRight','ArrowDown'].includes(event.key))index=(index+1)%departmentIds.length;
    else if(['ArrowLeft','ArrowUp'].includes(event.key))index=(index-1+departmentIds.length)%departmentIds.length;
    else return;
    event.preventDefault();selectDepartment(departmentIds[index],true);
  });
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('#menu-button,#shop-all-button,#footer-shop-all,[data-shop-department]');
    if(trigger){event.preventDefault();openShopAll(trigger,trigger.dataset.shopDepartment||null);}
    if(event.target.closest('#menu-retry'))loadMenu();
  });
  for(const button of document.querySelectorAll('#menu-button,#shop-all-button,#footer-shop-all,[data-shop-department]')){
    button.setAttribute('aria-haspopup','dialog');button.setAttribute('aria-controls','menu-dialog');button.setAttribute('aria-expanded','false');
  }
  menuDialog.addEventListener('close',()=>{
    for(const button of document.querySelectorAll('#menu-button,#shop-all-button,#footer-shop-all,[data-shop-department]'))button.setAttribute('aria-expanded','false');
    const replacement = ownedDepartment ? [...document.querySelectorAll('[data-shop-department]')].find(button => button.dataset.shopDepartment === ownedDepartment) : null;
    const restoreTarget = ownedTrigger?.isConnected ? ownedTrigger : replacement || document.querySelector('#menu-button');
    if(restoreTarget&&!document.querySelector('dialog[open]'))restoreTarget.focus({preventScroll:true});
    ownedTrigger=null;
    ownedDepartment=null;
  });
  menuDialog.addEventListener('toggle',event=>{
    if(event.newState==='open')for(const button of document.querySelectorAll('#menu-button,#shop-all-button,#footer-shop-all,[data-shop-department]'))button.setAttribute('aria-expanded','true');
  });
  mobile.addEventListener('change',()=>{setOrientation();if(menuDialog.open&&(tabs.contains(document.activeElement)||document.activeElement===mobileSelect))focusDepartmentControl();});
  loadMenu();
}
document.addEventListener('click', event => {
  const closer = event.target.closest('[data-close]');
  if (closer?.closest('dialog.xf-storefront,.xf-storefront dialog')) closer.closest('dialog').close();
  const anchor = event.target.closest('dialog.xf-storefront a[href],.xf-storefront dialog a[href]');
  if (!anchor) return;
  const destination = new URL(anchor.href, location.href);
  if (!destination.hash || destination.origin !== location.origin) return;
  anchor.closest('dialog').close();
  if (destination.pathname !== location.pathname) return;
  const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
  if (target) { target.setAttribute('tabindex','-1'); setTimeout(() => target.focus({preventScroll:true}),0); }
});
for (const dialog of document.querySelectorAll('dialog.xf-storefront,.xf-storefront dialog')) {
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
}
})();
